import React from 'react';
import type PolarisOnboardingPageType from '@atlassian/jira-spa-apps-polaris-onboarding/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyOnboardingPage = lazyForPaint<typeof PolarisOnboardingPageType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-polaris-onboarding", jiraSpaEntry: "async-polaris-ideas" */ '@atlassian/jira-spa-apps-polaris-onboarding'
			),
		),
	{ ssr: false },
);

const AsyncOnboardingPage = (): React.JSX.Element => (
	<LazyPage Page={LazyOnboardingPage} pageId="async-polaris-onboarding" shouldShowSpinner={false} />
);

export default AsyncOnboardingPage;
